module.exports = __webpack_public_path__ + "static/media/menu-close-dk.a1f9a918.svg";